import type { AppRole } from "../ux/model";

export interface FarmOption {
  farmId: string;
  farmName: string;
  role: AppRole;
}

export type FarmSelection =
  | { kind: "selected"; option: FarmOption }
  | { kind: "selection_required"; options: readonly FarmOption[] };

export function chooseFarmOption(
  options: readonly FarmOption[],
  preferredFarmId?: string,
): FarmSelection {
  const unique = new Map<string, FarmOption>();

  for (const option of options) {
    if (unique.has(option.farmId)) {
      throw new Error("C15_DUPLICATE_ACTIVE_FARM_MEMBERSHIP");
    }
    unique.set(option.farmId, option);
  }

  const normalized = [...unique.values()];

  if (normalized.length === 0) {
    throw new Error("C15_ACTIVE_MEMBERSHIP_REQUIRED");
  }

  if (preferredFarmId) {
    const preferred = unique.get(preferredFarmId);
    if (preferred) {
      return { kind: "selected", option: preferred };
    }
  }

  const only = normalized[0];
  if (normalized.length === 1 && only) {
    return { kind: "selected", option: only };
  }

  return { kind: "selection_required", options: normalized };
}
